const slugify = (name: string) => {
	return name
		.replace(/[`~!@#$%^&*_|=?;'",<>{}[\]\\]/gi, "")
		.replace(/[`~!@#$%^&*()_|+\-=?;'",.<>{}[\]\\/]/gi, "")
		?.trim()
		?.replace(/ /g, "-")
		?.replace(/(-+){2}/g, "-")
		?.replace(/\//g, "")
		?.replace(/&/g, "and")
		?.toLowerCase();
};

export default slugify;
